<p-confirmDialog key="updateallconfirmrebuild" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="updatealldoublecheckrebuild" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="updateall" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Info-->
<div class="ItemBorder">
	<div class="GridTwoCol">
		<label>ScanStations to Update:</label>
		<label class="InfoText">{{ ScanStationCount }}</label>
	</div>
</div>

<!--Options-->
<div class="ItemBorder TopMargin MainGrid2Col">
	<label>Active:</label>
	<select [disabled]="IsLoading() == true" class="form-control" name="ActiveOption" [(ngModel)]="ActiveOption" [style.color]="ActiveOption.Color">
		<option value="" style="display: none"></option>
		<option *ngFor="let o of lstActiveOptions" [ngValue]="o" [style.color]="o.Color">{{ o.Desc }}</option>
	</select>

	<label>Rebuild:</label>
	<select [disabled]="IsLoading() == true" class="form-control" name="RebuildOption" [(ngModel)]="RebuildOption" [style.color]="RebuildOption.Color">
		<option value="" style="display: none"></option>
		<option *ngFor="let o of lstRebuildOptions" [ngValue]="o" [style.color]="o.Color">{{ o.Desc }}</option>
	</select>

	<label>Entry Mode:</label>
	<select [disabled]="IsLoading() == true" class="form-control" name="EntryOption" [(ngModel)]="EntryOption" [style.color]="EntryOption.Color">
		<option value="" style="display: none"></option>
		<option *ngFor="let o of lstModeOptions" [ngValue]="o" [style.color]="o.Color">{{ o.Desc }}</option>
	</select>

	<label>Exit Mode:</label>
	<select [disabled]="IsLoading() == true" class="form-control" name="ExitOption" [(ngModel)]="ExitOption" [style.color]="ExitOption.Color">
		<option value="" style="display: none"></option>
		<option *ngFor="let o of lstModeOptions" [ngValue]="o" [style.color]="o.Color">{{ o.Desc }}</option>
	</select>

	<label>Meal Mode:</label>
	<select [disabled]="IsLoading() == true" class="form-control" name="MealOption" [(ngModel)]="MealOption" [style.color]="MealOption.Color">
		<option value="" style="display: none"></option>
		<option *ngFor="let o of lstModeOptions" [ngValue]="o" [style.color]="o.Color">{{ o.Desc }}</option>
	</select>

	<label>Access Mode:</label>
	<select [disabled]="IsLoading() == true" class="form-control" name="AccessOption" [(ngModel)]="AccessOption" [style.color]="AccessOption.Color">
		<option value="" style="display: none"></option>
		<option *ngFor="let o of lstModeOptions" [ngValue]="o" [style.color]="o.Color">{{ o.Desc }}</option>
	</select>

	<label>TimeStamp Mode:</label>
	<select [disabled]="IsLoading() == true" class="form-control" name="TimeStampOption" [(ngModel)]="TimeStampOption" [style.color]="TimeStampOption.Color">
		<option value="" style="display: none"></option>
		<option *ngFor="let o of lstModeOptions" [ngValue]="o" [style.color]="o.Color">{{ o.Desc }}</option>
	</select>

	<label>Event Mode:</label>
	<select [disabled]="IsLoading() == true" class="form-control" name="EventOption" [(ngModel)]="EventOption" [style.color]="EventOption.Color">
		<option value="" style="display: none"></option>
		<option *ngFor="let o of lstModeOptions" [ngValue]="o" [style.color]="o.Color">{{ o.Desc }}</option>
	</select>

	<label>SQLServerName:</label>
	<select [disabled]="IsLoading() == true" class="form-control" name="SqlServerOption" [(ngModel)]="SqlServerOption" [style.color]="SqlServerOption.Color">
		<option value="" style="display: none"></option>
		<option *ngFor="let o of lstSqlServerOption" [ngValue]="o" [style.color]="o.Color">{{ o.Desc }}</option>
	</select>

	<label>Facility:</label>
	<select
		[disabled]="IsLoading() == true"
		class="form-control"
		name="FacilityOption"
		[(ngModel)]="FacilityOption"
		[style.color]="FacilityOption.Color"
		(ngModelChange)="onFacilityOptionChange($event)"
	>
		<option value="" style="display: none"></option>
		<option *ngFor="let o of lstFacilityOption" [ngValue]="o" [style.color]="o.Color">{{ o.Desc }}</option>
	</select>

	<label>Facility Location:</label>
	<select
		[disabled]="IsLoading() == true"
		class="form-control"
		name="FacilityLocationOption"
		[(ngModel)]="FacilityLocationOption"
		[style.color]="FacilityLocationOption.Color"
	>
		<option value="" style="display: none"></option>
		<option *ngFor="let o of lstFacilityLocationOption" [ngValue]="o" [style.color]="o.Color">{{ o.Desc }}</option>
	</select>
</div>

<!--Buttons-->
<div class="Buttons">
	<button class="btn btn-primary" (click)="onUpdate()" [disabled]="IsLoading() == true">Update</button>
	<button class="btn btn-warning LeftMargin" (click)="onClose()" [disabled]="Processing == true">Cancel</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
</div>
